import React, { useEffect } from "react";
import { Form, Checkbox, Radio, Input, Row, Col, message } from "antd";

const Section4 = ({
  formValues,
  setFormValues,
  validationErrors,
  setValidationErrors,
}) => {
  // Gather all services selected in Section 3
  // const selectedServices = [
  //   ...(formValues.creativeProduction || []),
  //   ...(formValues.digitalMarketing || []),
  //   ...(formValues.advertisingChannels || []),
  //   ...(formValues.publicEngagement || []),
  // ];
const selectedServices = [
  ...(formValues.creativeProduction || []),
  ...(formValues.digitalMarketing || []),
  ...(formValues.advertisingChannels || []),
  ...(formValues.publicEngagement || []),
];

const uniqueServices = Array.from(new Set(selectedServices));
// Only add Other if not already included
// Strict subset of Section 3 answers (no automatic “Other”)
// const coreSpecialtyOptions = uniqueServices;
const coreSpecialtyOptions = uniqueServices.includes("Other (please specify)")
  ? uniqueServices
  : [...uniqueServices, "Other (please specify)"];

// useEffect(() => {
//   if (!formValues.coreSpecialties?.includes("Other (please specify)") &&
//       formValues.otherCoreSpecialty) {
//     setFormValues(prev => ({ ...prev, otherCoreSpecialty: "" }));
//   }
// }, [formValues.coreSpecialties]);

  //Core specialties user can select (only from Section 3 choices)
  // const coreSpecialtyOptions = [
  //   "Social Media Management",
  //   "Media Buying (TV, Radio, Digital)",
  //   "Video/Commercial Production",
  //   "Website Design & Development",
  //   "Branding & Graphic Design",
  //   "SEO/SEM",
  //   "Content Creation (e.g., blogs, copywriting)",
  //   "Event Marketing & Promotion",
  //   "Email Marketing",
  //   "Public Relations",
  //   "Market Research & Strategy",
  //   "Web Hosting/Technical Services",
  //   "Other (please specify)",
  // ];

  // Limit to 5 selections max
  const handleCoreSpecialtyChange = (checkedValues) => {
    if (checkedValues.length > 5) {
      message.warning("⚠️ You can select up to 5 core specialties only.");
      return;
    }
    setFormValues({ ...formValues, coreSpecialties: checkedValues });
  };

  // Validation: If they select a specialty that wasn’t in Section 3 (manually injected)
  useEffect(() => {
    const selectedServices = [
      ...(formValues.creativeProduction || []),
      ...(formValues.digitalMarketing || []),
      ...(formValues.advertisingChannels || []),
      ...(formValues.publicEngagement || []),
    ];

    const invalidSelections = (formValues.coreSpecialties || []).filter(
      (specialty) =>
        specialty !== "Other (please specify)" &&
        !selectedServices.includes(specialty)
    );

    if (invalidSelections.length > 0) {
      setValidationErrors((prev) => ({
        ...prev,
        coreSpecialties:
          "Some selected specialties weren’t chosen in Section 3 services. Please review.",
      }));
    } else {
      setValidationErrors((prev) => ({
        ...prev,
        coreSpecialties: null,
      }));
    }
  }, [
    formValues.coreSpecialties,
    formValues.creativeProduction,
    formValues.digitalMarketing,
    formValues.advertisingChannels,
    formValues.publicEngagement,
  ]);

  return (
    <Form layout="vertical">
      {/*Core Specialties */}
      <Form.Item label="17. Of the services you selected above, which 5 are your core specialties? (Select up to 5)">
        {/* {coreSpecialtyOptions.length === 0 && (
          <div style={{ color: '#999', marginBottom: 12 }}>
            Pick services in Section 3 first; your options will appear here.
          </div>
        )} */}
        <Checkbox.Group
          // disabled={coreSpecialtyOptions.length === 0}
          value={formValues.coreSpecialties || []}
          onChange={handleCoreSpecialtyChange}
          style={{ width: "100%" }}
        >
          <Row gutter={[0, 8]}>
            {coreSpecialtyOptions.map((option) => (
              <Col span={12} key={option}>
                <Checkbox value={option}>{option}</Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>

        {/* Validation message */}
        {validationErrors?.coreSpecialties && (
          <div style={{ color: "red", fontWeight: "bold", marginTop: "8px" }}>
            {validationErrors.coreSpecialties}
          </div>
        )}
      </Form.Item>

      {/* Other (if selected) */}
      {formValues.coreSpecialties?.includes("Other (please specify)") && (
        <Form.Item label="Please specify your other specialty">
          <Input
            placeholder="Enter additional specialty"
            value={formValues.otherCoreSpecialty || ""}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                otherCoreSpecialty: e.target.value,
              })
            }
          />
        </Form.Item>
      )}

      {/* Follow-up: Comfort matching for services */}
      <Form.Item label=" 18. Would you be comfortable being matched primarily for the services you selected above?">
        <Radio.Group
          value={formValues.matchComfort}
          onChange={(e) =>
            setFormValues({ ...formValues, matchComfort: e.target.value })
          }
        >
          <Radio value="Yes">Yes</Radio>
          <Radio value="No">No</Radio>
          <Radio value="Depends">Depends (please explain)</Radio>
        </Radio.Group>
      </Form.Item>

      {/* If Depends → explanation */}
      {formValues.matchComfort === "Depends" && (
        <Form.Item label="Please explain your answer">
          <Input.TextArea
            placeholder="Explain under what conditions you’d accept being matched."
            value={formValues.matchComfortExplanation || ""}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                matchComfortExplanation: e.target.value,
              })
            }
          />
        </Form.Item>
      )}

      {/* Campaign Execution Type */}
      <Form.Item label="19. Do you manage full campaign execution, or only place media buys?">
        <Radio.Group
          value={formValues.campaignExecution}
          onChange={(e) =>
            setFormValues({ ...formValues, campaignExecution: e.target.value })
          }
        >
          <Radio value="Full">We manage full campaign execution</Radio>
          <Radio value="Media Buys Only">We primarily place media buys</Radio>
          <Radio value="Both">We do both depending on the project</Radio>
          <Radio value="Neither">Neither</Radio>
        </Radio.Group>
      </Form.Item>

      {/* Average Campaign Lead Time */}
      <Form.Item label="20. What is your average campaign lead time from intake to launch?">
        <Radio.Group
          value={formValues.leadTime}
          onChange={(e) =>
            setFormValues({ ...formValues, leadTime: e.target.value })
          }
        >
          <Radio value="Less than 1 week">Less than 1 week</Radio>
          <Radio value="1–2 weeks">1–2 weeks</Radio>
          <Radio value="3–4 weeks">3–4 weeks</Radio>
          <Radio value="1–2 months">1–2 months</Radio>
          <Radio value="More than 2 months">More than 2 months</Radio>
          <Radio value="Varies significantly">
            It varies significantly by project
          </Radio>
          <Radio value="Not sure">
            Not sure / we don’t manage campaign launches
          </Radio>
        </Radio.Group>
      </Form.Item>
    </Form>
  );
};

export default Section4;
